// components/UserTour/tourConfigs.js

export const LANGUAGE_DASHBOARD_TOUR = {
  id: 'language-dashboard',
  title: 'Language Dashboard Tour',
  description: 'Learn how to navigate your language learning dashboard',
  steps: [
    {
      id: 'view-course',
      target: '[data-tour="view-course"]',
      title: 'View Course',
      content: 'Click here to explore your current course content and see what you\'re learning. This shows your "NOW LEARNING" section.',
      position: 'bottom', // Tooltip appears below (default)
      highlightPadding: 8
    },
    {
      id: 'goal-commitment',
      target: '[data-tour="goal-commitment"]',
      title: 'Goal Commitment',
      content: 'This shows your current commitment level. You can view and edit your daily learning goals here. Goals are measured in new sentences learned per day.',
      position: 'bottom', // Tooltip appears below (default)
      highlightPadding: 8
    },
    {
      id: 'level-progress',
      target: '[data-tour="level-progress"]',
      title: 'Level Progress',
      content: 'Track your current level and see how much XP you need to level up. You gain XP primarily by reviewing existing items. Higher memorization levels give more XP!',
      position: 'bottom', // Tooltip appears below (default)
      highlightPadding: 12
    },
    {
      id: 'learning-progress',
      target: '[data-tour="learning-progress"]',
      title: 'Learning Progress',
      content: 'See how far you\'ve progressed in your language learning journey. This shows your overall course completion and learning statistics.',
      position: 'bottom', // Tooltip appears below (default)
      highlightPadding: 12
    },
    {
      id: 'start-learning',
      target: '[data-tour="start-learning"]',
      title: 'Start Learning',
      content: 'Begin learning new sentences and vocabulary by clicking here. This helps you complete today\'s learning goal.',
      position: 'bottom', // Tooltip appears below (default)
      highlightPadding: 12
    },
    {
      id: 'review-session',
      target: '[data-tour="review-session"]',
      title: 'Review Session',
      content: 'Review your previously learned items to level up and consolidate knowledge into long-term memory. We use spaced repetition for maximum retention.',
      position: 'bottom', // Tooltip appears below (default)
      highlightPadding: 12
    },
    {
      id: 'streaks',
      target: '[data-tour="streaks"]',
      title: 'Streaks',
      content: 'Track your current learning streak and see how often you\'ve completed your daily goals this month. Consistency is key!',
      position: 'bottom', // Tooltip appears below (default)
      highlightPadding: 12
    },
    {
      id: 'learning-summary',
      target: '[data-tour="learning-summary"]',
      title: 'Learning Summary and Stats',
      content: 'Track your most recently learned items and review them by clicking on any sentence or word. This is your learning history.',
      position: 'top', // Tooltip appears above for bottom section elements
      highlightPadding: 16
    },
    {
      id: 'games-chat',
      target: '[data-tour="games-chat"]',
      title: 'Games & AI Chat',
      content: 'Play fun games or chat with AI to reinforce your language skills. These activities make learning enjoyable and help with retention.',
      position: 'top', // Tooltip appears above for bottom section elements
      highlightPadding: 16
    }
  ]
};

export const FINAL_STEP_CONFIG = {
  target: '[data-tour="user-avatar"]',
  title: 'Access Tour Anytime',
  content: 'You can access this user tour anytime in the future by clicking on your avatar and selecting "How to use" from the menu.',
  position: 'bottom', // Tooltip appears below (default)
  highlightPadding: 8
};

// Helper function to get tour config by ID
export const getTourConfig = (tourId) => {
  switch (tourId) {
    case 'language-dashboard':
      return LANGUAGE_DASHBOARD_TOUR;
    default:
      return null;
  }
};

// 🛡️ SIMPLIFIED: Basic position utility - positioning is now handled with fixed offsets
export const getTooltipPosition = (target, position, tooltipRect) => {
  // This function is deprecated as TourTooltip now uses simplified fixed offset positioning
  // Kept for backward compatibility only
  
  if (!target || !tooltipRect) {
    return { 
      top: window.pageYOffset + window.innerHeight / 2 - 100, 
      left: (window.innerWidth - 400) / 2 
    };
  }
  
  const targetRect = target.getBoundingClientRect();
  const scrollY = window.pageYOffset;
  
  // Simple fallback positioning
  return {
    top: targetRect.bottom + scrollY + 16,
    left: Math.max(16, Math.min(
      targetRect.left + (targetRect.width - tooltipRect.width) / 2,
      window.innerWidth - tooltipRect.width - 16
    ))
  };
};